import { Box, Container, Typography } from '@mui/material';
import PageHeader from 'components/PageHeader';
import VideoSwitcher from 'components/VideoSwitcher';
import WrapperBackgroundGraphics from 'components/WrapperBackgroundGraphics';
import { useState } from 'react';
import { getEnv } from 'utils';
import { useStyles } from './styles';
import CustomButton from 'components/CustomButton';
import Link from 'next/link';
import Video from 'components/Video';
import useIsMobile from 'hooks/useIsMobile';
import LazyLoad from 'react-lazyload';
import EditageHeader from 'components/EditageHeader';
import NavBarOneResearcher from 'components/NavBarOneResearcher';

const routes = [
  {
    path: '/my-creations',
    label: '포스터 제작',
    isLogged: true,
  },
  {
    path: '/illustrations',
    label: '갤러리',
  },
  {
    path: '/infographic-templates',
    label: '템포스터 제작',
  },
  {
    path: '/pricing',
    label: '템플릿',
  },
  {
    path: '/institutions',
    label: '요금제',
  },
  {
    path: '/custom-services',
    label: '맞춤 디자인',
  },
  {
    path: '/about-us',
    label: '회사 소개',
  },
  {
    path: `${getEnv('MTG_URL_APP')}/blog`,
    label: '블로그',
    isExternal: true,
    isBlank: true,
  },
];

export default function Header() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const classes = useStyles();
  const isMobile = useIsMobile();

  return (
    <>
      <NavBarOneResearcher localeProp="ko" />

      <PageHeader
        brandSrc="/images/mtg-logo-red-editage.svg"
        brandAlt="Mind the Graph"
        brandHref="/"
        menuItems={routes}
        isNavOpen={isNavOpen}
        onNavClose={() => setIsNavOpen(false)}
        onNavOpen={() => setIsNavOpen(true)}
        typeBtn="buttonSecondary"
        scrolled={false}
        hamburgerMenuActive={false}
        headerWhite={true}
        textSignIn="로그인"
        textSignUp="바로 시작"
      />

      <WrapperBackgroundGraphics>
        <Container>
          <Box className={classes.content}>
            <Box>
              <Typography component="h1" variant="h4">
                <b>
                  과학/학술 일러스트레
                  <br />
                  이션은 “Mind The <br />
                  Graph” 로 완성
                </b>
              </Typography>

              <Box pt={2}>
                <Typography className={classes.subheadline}>
                  80개 이상의 연구분야 및 40,000개 이상의 과<br />
                  학 일러스트레이션으로 연구를 시각적으로 전<br />
                  달해 보세요.
                </Typography>
              </Box>

              <Box pt={2}>
                <Link href="/pricing">
                  <CustomButton>바로 시작하기</CustomButton>
                </Link>
              </Box>
            </Box>
            {isMobile && (
              <Box className={classes.videoWrapper} mb={-25}>
                <LazyLoad offset={50}>
                  <Video
                    className={classes.video}
                    sources={[
                      { src: '/videos/new-header-banner-new-workspace.webm', type: 'video/webm' },
                    ]}
                  />
                </LazyLoad>
              </Box>
            )}

            {!isMobile && <VideoSwitcher />}
          </Box>
        </Container>
      </WrapperBackgroundGraphics>
    </>
  );
}
